import Modal from '@tian-libs/modal'

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.use(Modal)
})
  